import { createFeatureSelector, createSelector } from '@ngrx/store';

import * as fromStaticDataReducer from '../reducers';
import * as staticDataRejectionReducer from '../reducers/index';
import * as staticDataReducer from '../static-data.reducer';

//#region Static Data ROOT STATE
export const getAuthState = createFeatureSelector<staticDataReducer.State, staticDataReducer.StaticDataState>(
  staticDataReducer.staticDataFeatureKey
);
//#endregion

export const getStaticDataRejectionReasonState = createSelector(
  getAuthState,
  state => state[fromStaticDataReducer.fromStaticDataRejectionReasonReducer.rejectionReasonFeatureKey]
);

export const getStaticDataRejectionFailure = createSelector(
  getStaticDataRejectionReasonState,
  staticDataRejectionReducer.fromStaticDataRejectionReasonReducer.getStaticDataRejectionFailure
);

export const getStaticDataRejectionResponse = createSelector(
  getStaticDataRejectionReasonState,
  staticDataRejectionReducer.fromStaticDataRejectionReasonReducer.getStaticDataRejectionResponse
);
